import { useCallback, useEffect, useState } from 'react';

export default function useVpayAccount(api) {
  const [state, setState] = useState({ loading: true });
  const refresh = useCallback(async () => {
    const account = await api.getAccount();
    setState({ account, loading: false });
  }, [api]);
  useEffect(() => {
    let active = true;
    setState({ loading: true });
    api.getAccount().then(
      account => {
        if (active) setState({ account, loading: false });
      },
      error => {
        if (active) setState({ error, loading: false });
      },
    );
    return () => {
      active = false;
    };
  }, [api]);
  const retry = async () => {
    setState({ loading: true });
    try {
      await refresh();
    } catch (error) {
      setState({ error, loading: false });
    }
  };

  return { state, refresh, retry };
}
